import { render, staticRenderFns } from "./selectSchool.vue?vue&type=template&id=bfee2048"
import script from "./selectSchool.vue?vue&type=script&lang=js"
export * from "./selectSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports